<script setup>

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  textSize: {
    type: String,
    default: "text-h5",
  },
  allowBadge: {
    type: Boolean,
    default: false,
  },
  badgeContent: {
    type: [String, Number],
    default: '0',
  },
  allowChip: {
    type: Boolean,
    default: false,
  },
  chipContent: {
    type: null, // Accept any type, including VNode
    default: null,
  },
})
</script>

<template>
  <div class="d-flex align-center">
    <VDivider class="flex-grow-1" />
    <VBadge
      v-if="props.allowBadge"
      offset-x="-8"
      offset-y="12"
      :content="props.badgeContent"
      style="z-index: 20000"
    >
      <span
        :class="props.textSize"
        class="mx-2 font-weight-medium whitespace-no-wrap"
      >{{ text }}</span>
    </VBadge>
    <span
      v-else
      :class="props.textSize"
      class="mx-2 font-weight-medium whitespace-no-wrap"
    >
      {{ text }}
    </span>
    <div
      v-if="props.allowChip"
      class="mx-1 d-flex align-center"
    >
      <slot name="chip">
        <component :is="props.chipContent" />
      </slot>
    </div>

    <VDivider class="flex-grow-1" />
  </div>
</template>
